import { ComboboxData } from "@mantine/core";
import { FormValidateInput } from "@mantine/form";
import { TFunction } from "i18next";

import { IReadKeyParams } from "@prostocheck/data-web";
import {
  CA_AUTO_DETECT_VALUE,
  ICertificateAuthority,
} from "@prostocheck/shared";

/**
 * ЦСК names come from the registry as they are — they are never translated.
 * The auto-detect option is synthetic, so it goes first and carries a
 * translated label instead.
 */
export const toAuthorityOptions = (
  authorities: ICertificateAuthority[],
  t: TFunction,
): ComboboxData => [
  { value: CA_AUTO_DETECT_VALUE, label: t("login.key.authorityAuto") },
  ...authorities.map(({ cmpUrl, name }) => ({ value: cmpUrl, label: name })),
];

/**
 * The three things `readKey` cannot work without. Reading a container decrypts
 * a file and calls the ЦСК, so an empty field is caught here instead of coming
 * back as a `SimpleResult` half a second later.
 */
export const createKeyFormValidation = (
  t: TFunction,
): FormValidateInput<IReadKeyParams> => ({
  file: value => (value ? null : t("login.key.errors.file")),
  password: value => (value ? null : t("login.key.errors.password")),
  cmpUrl: value => (value ? null : t("login.key.errors.authority")),
});
